import { connect } from 'react-redux';

import { fetchQCSummary, fetchQCMetadata } from 'ducks/qcReports';
import { parsePaginationParams } from 'utils/location';

import TableView from 'components/TableView';
import { QCErrorSeveritySummaryTable, QCMetadataTable } from 'components/Tables';
import { QCSummaryToolbar } from 'components/Toolbars/index';
import QCErrorDownloadContainer from 'containers/DownloadContainers/QCErrorDownloadContainer';

import { HEADER_HEIGHT, TOP_NAV_HEIGHT } from 'style/dimensions';
import Column from 'components/UIKit/Flex/Column';
import Row from 'components/UIKit/Flex/Row';
import withRouting from 'utils/withRouting';

const QC_PAGINATION_DEFAULTS = {
  sort: 'severity',
  order: 'desc',
};

const styles = {
  h1: {
    margin: '1rem 0',
    fontFamily: 'inherit',
  },
  h2: {
    margin: '0.5rem 5rem 0.5rem 0',
    fontSize: '1.4rem',
    fontFamily: 'inherit',
  },
};

const enhance = connect(({
  qcReports,
  notifications,
}) => ({
  qcReports,
  notifications,
}));

class QCSummary extends React.Component {
  componentDidMount = () => {
    const {
      dispatch,
      router: {
        params: {
          program,
          project,
        },
      },
    } = this.props;

    dispatch(fetchQCSummary({ program, project }));
    dispatch(fetchQCMetadata({ projectId: `${program}-${project}` }));
  }

  componentDidUpdate = (prevProps) => {
    const {
      dispatch,
      router: {
        params: {
          program,
          project,
        },
      },
    } = this.props;

    const { router: { params: { program: prevProgram, project: prevProject } } } = prevProps;

    if (program !== prevProgram && project !== prevProject) {
      dispatch(fetchQCSummary({ program, project }));
      dispatch(fetchQCMetadata({ projectId: `${program}-${project}` }));
    }
  }

  render() {
    const {
      notifications,
      qcReports: { summaryData, metadata },
      router,
      router: { params: { program, project } },
    } = this.props;
    const { sort, order } = parsePaginationParams(router, QC_PAGINATION_DEFAULTS);

    return (
      <Column style={{ flex: 1, padding: '1rem', overflow: 'scroll' }}>
        <h1 className="qc-summary pdf-only" style={styles.h1}>
          {`${program}-${project}: Pre-Harmonization QC Report`}
        </h1>
        <Row className="qc-summary pdf-only" style={{ alignItems: 'center' }}>
          <h2 className="qc-summary pdf-only" style={styles.h2}>Project Summary</h2>
          <QCErrorDownloadContainer
            download={() => window.print()}
            formats={['pdf']}
            >
            Download QC Report
          </QCErrorDownloadContainer>
        </Row>

        <Column>
          <QCMetadataTable metadata={metadata} />
        </Column>

        <Column data-testid="table-qc-errors" className="qc-summary pdf-only">
          { TableView({
            router,
            list: summaryData,
            sort,
            order,
            entity: 'errors',
            IconComponent: () => <div />,
            TableComponent: QCErrorSeveritySummaryTable,
            ToolbarComponent: () => null,
            // ToolbarComponent: QCSummaryToolbar,
            height: `calc(100vh - ${(1 + notifications.filter(n => !n.dismissed).length) * HEADER_HEIGHT + TOP_NAV_HEIGHT}rem)`,
            hidePagination: true,
            title: 'Error Summary',
            subtitle: 'Counts of errors per type in current unsubmitted batch.',
            width: 'fit-content',
          }) }
        </Column>
        {/* This is meant to be a temporary solution, API will fix the summary detail endpoint
        Thus, only adding changes here (e.g. inline styles), to keep other lines unchanged */}
        <Column className="qc-summary pdf-only" style={{ marginTop: '2rem' }}>
          <p style={{ fontSize: '0.9rem', fontWeight: 300 }}>
            {'For a list of specific criteria used to classify CRITICAL and WARNING errors, see the '}
            <a
              href="https://docs.gdc.cancer.gov/Data_Submission_Portal/Users_Guide/Data_Submission_Process/#pre-harmonization-checklist"
              rel="noreferrer noopener"
              target="_blank"
              >
              pre-harmonization checklist
            </a>
            .
            <br />
            {'To obtain the actual errors to resolve, use the navigation panel on the left to view and download error lists by node type.'}
          </p>
          <p style={{ fontSize: '0.9rem', fontWeight: 300 }}>
            {'Note that the QC errors are not checked for in real-time and a status delay of up to a few hours may be observed.'}
          </p>
        </Column>
      </Column>
    );
  }
}

export default enhance(withRouting(QCSummary));
